import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { T } from "@freightsimple/ui-core/Typography/T";
import YellowExclamationAnimatedIcon from "@/Shared/Animations/YellowExclamationAnimatedIcon";

interface LoadFailedProps {
  /** Runs the screen's load again. */
  onRetry: () => void;
}

/**
 * What a screen shows in place of its content when the data it needs could
 * not be loaded (a 5xx, a timeout, a dropped connection). Never shown for a
 * 404: a missing shipment or draft keeps its own "not found" copy, because
 * retrying won't make it appear.
 */
export function LoadFailed(props: LoadFailedProps) {
  return (
    <Center minHeight="60vh">
      <Stack gap={5} align="center">
        <YellowExclamationAnimatedIcon size={80} />
        <Stack gap={0} align="center">
          <Heading level={2} align="center">
            We couldn&apos;t load this
          </Heading>
          <T size="base" color="secondary" align="center">
            Something went wrong on our end. Please try again.
          </T>
        </Stack>
        <Button primary onClick={props.onRetry} data-testid="load-failed-retry">
          Try again
        </Button>
      </Stack>
    </Center>
  );
}
